import React, { useEffect, useMemo, useState } from 'react';
import { findImportantTerms, matchTermsInText, wikipediaSearchUrl } from '../../services/importantTerms';
import { resolveTermLinks } from '../../services/termLinkApi';
import './ImportantTermText.css';

export default function ImportantTermText({ text, disableLinks = false }) {
  const content = typeof text === 'string' ? text : text == null ? '' : String(text);
  const [lookup, setLookup] = useState({ status: 'pending', terms: [] });
  useEffect(() => {
    let active = true;
    setLookup({ status: 'pending', terms: [] });
    if (!content || content.trim().length < 8 || disableLinks) {
      setLookup({ status: 'success', terms: [] });
    } else {
      resolveTermLinks(content)
        .then(terms => { if (active) setLookup({ status: 'success', terms }); })
        .catch(error => {
          console.warn('Using Wikipedia term links; contextual lookup failed:', error.message);
          if (active) setLookup({ status: 'fallback', terms: [] });
        });
    }
    return () => { active = false; };
  }, [content, disableLinks]);

  const matches = useMemo(() => {
    if (disableLinks) return [];
    if (lookup.status === 'fallback') {
      return findImportantTerms(content).map(term => ({
        ...term,
        url: wikipediaSearchUrl(term.text),
        sourceLabel: 'Wikipedia search',
      }));
    }
    return matchTermsInText(content, lookup.terms);
  }, [content, lookup, disableLinks]);
  if (!content) return null;
  if (typeof text !== 'string') return content;
  if (!matches.length) return text;

  const parts = [];
  let cursor = 0;
  matches.forEach((match, index) => {
    if (match.start > cursor) parts.push(content.slice(cursor, match.start));
    parts.push(
      <a
        key={`${match.start}-${index}`}
        className="important-term-link"
        href={match.url || wikipediaSearchUrl(match.text)}
        target="_blank"
        rel="noopener noreferrer"
        title={match.sourceLabel
          ? `Learn about ${match.text} (${match.sourceLabel})`
          : `Find reliable sources about ${match.text}${match.sources?.length ? ` at ${match.sources.slice(0, 3).join(', ')}` : ''}`}
      >
        {match.text}
      </a>,
    );
    cursor = match.end;
  });
  if (cursor < content.length) parts.push(content.slice(cursor));
  return parts;
}
